<span class="baseline-text">
  Together, this data indicated that you {{overallScoreText}}.
</span>
